import { Card, CardBody, Col } from "reactstrap";
import { ProductTittle, Symbol } from "../../../../../constants";
import { ProductColors } from "../../../../../data/applications/ECommerce";
import Buttons from "./Buttons";
import Review from "./Review";
import SocialLinks from "./SocialLinks";
import List from "./List";

// A component that displays detailed information about a product, including price, colors, additional features, and customer reviews.
const Details = () => {

  return (
    <Col xxl="5" className="box-col-6 order-xxl-0 order-1">
      <Card>
        <CardBody>
          <div className="product-page-details">
            <h3>{ProductTittle}</h3>
          </div>
          <div className="product-price">
            {Symbol}26.00<del>{Symbol}350.00 </del>
          </div>
          <ul className="product-color">
            {ProductColors.map((item, index) => <li className={`bg-${item}`} key={index} />)}
          </ul>
          <hr />
          <p>{"Rock Paper Scissors Various Dots Half Sleeves Girl’s Regular Fit T-Shirt I 100% Cotton T Shirt with Half Sleeve Round Neck I Regular Wear Solid Kids Tees and Black Sleeve."}</p>
          <hr />
          <List />
          <hr />
          <SocialLinks />
          <hr />
          <Review />
          <hr />
          <Buttons />
        </CardBody>
      </Card>
    </Col>
  );
};

export default Details;